import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import { signupCognitoUser } from '@utils/authenticateService'
import { history } from '@components/App'
import routes from '@utils/constants/routes'
import { ISignupPayload } from '@app-store/slices/auth/signup.slice'

interface TaskAction extends Action, ITask {}
interface ITask {
    payload: ISignupPayload
}

const { onFailure, onSuccess, onRequest } = rootActions.auth.signup

function* fetchSignupSaga({ payload }: TaskAction) {
    try {
        yield signupCognitoUser(payload)
        history.replace({
            pathname: routes.sign_up.email_confirm._
        })
        yield put(onSuccess({}))
    } catch (e) {
        yield put(onFailure(e))
    }
}

function* SignupSaga(): any {
    yield takeLatest<TaskAction>(onRequest, fetchSignupSaga)
}

export default SignupSaga
